import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const BASE44_APP_URL = 'https://proud-clear-mind-flow.base44.app';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const logoUrl = 'https://media.base44.com/images/public/6a33f776ca9ab1423a01beaf/3117d87bb_clearmind_icon_white_background.png';

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src={logoUrl}
            alt="ClearMind Club"
            className="w-9 h-9 object-contain"
          />
          <span className="font-heading font-semibold text-lg text-foreground-950">
            ClearMind Club
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent-100 hover:text-accent-800 h-9 rounded-md px-4 text-sm text-foreground-800"
          >
            Home
          </Link>
          <Link
            to="/blog"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent-100 hover:text-accent-800 h-9 rounded-md px-4 text-sm text-foreground-800"
          >
            Blog
          </Link>
          <Link
            to="/course"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent-100 hover:text-accent-800 h-9 rounded-md px-4 text-sm text-foreground-800"
          >
            Course
          </Link>
          <Link
            to="/knowledge-hub"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent-100 hover:text-accent-800 h-9 rounded-md px-4 text-sm text-foreground-800"
          >
            Knowledge Hub
          </Link>
          <a
            href={BASE44_APP_URL}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent-100 hover:text-accent-800 h-9 rounded-md px-4 text-sm text-foreground-800"
          >
            Get the App
          </a>
          <Link
            to="/community"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 bg-accent-500 text-foreground-950 hover:bg-accent-700 h-9 rounded-md px-4 text-sm"
          >
            Join Community
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/70 px-4 py-4 flex flex-col gap-2">
          <Link
            to="/"
            className="flex items-center justify-center py-3 text-sm font-label font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/blog"
            className="flex items-center justify-center py-3 text-sm font-label font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Blog
          </Link>
          <Link
            to="/course"
            className="flex items-center justify-center py-3 text-sm font-label font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Course
          </Link>
          <Link
            to="/knowledge-hub"
            className="flex items-center justify-center py-3 text-sm font-label font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Knowledge Hub
          </Link>
          <a
            href={BASE44_APP_URL}
            className="flex items-center justify-center py-3 text-sm font-label font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Get the App
          </a>
          <Link
            to="/community"
            className="flex items-center justify-center py-3 text-sm font-label font-medium bg-accent-500 text-foreground-950 hover:bg-accent-700 rounded-md transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Join Community
          </Link>
        </div>
      )}
    </nav>
  );
}